import api from "src/api/axios";

const getDashboardData = async () => {
  return api.get("/dashboard").then((result) => {
    return result.data;
  });
};

export { getDashboardData };
